import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "src/shared/shared.module";
import { WelcomePage } from "./welcome";
import { WelcomeRestylePage } from "./welcome-restyle/welcome-restyle";
import { IonAccordion, IonicModule } from "@ionic/angular";
const routes: Routes = [
    { path: '', loadComponent: () =>
      import('./welcome').then(m => m.WelcomePage)
    },
    { path: 'restyle', loadComponent: () =>
      import('./welcome-restyle/welcome-restyle').then(m => m.WelcomeRestylePage)
    }
  ];
@NgModule({
    declarations: [
      WelcomePage,
      WelcomeRestylePage
    ],
    imports: [
        HttpClientModule,
        SharedModule,
        CommonModule,
        IonicModule,
        RouterModule,
        SharedModule,
        RouterModule.forChild(routes)

    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
    ]
  })
  export class WelcomeModule { }
  export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }